// extracted by mini-css-extract-plugin
export default {"container":"styles_container__yRYtW","arrow":"styles_arrow__doFWJ","moveArrow":"styles_moveArrow__rGwjZ","secondArrow":"styles_secondArrow__84kYa"};